// Gravity Forms Post Render 
jQuery(document).on('gform_post_render', function(event, form_id, current_page) {

    jQuery('.gform_body input').each(function(i, obj) {

        let current_gf_field = jQuery(this).attr('value');
        
        if (current_gf_field.startsWith('http') && current_gf_field.includes('salesgenie.com')) {

            jQuery(this).attr('value', window.location.href);

        }

    });
 
    // Gravity Form 12, the Seamless Registration form
    if (form_id === 18) {
 
        const nxg_username = Cookies.get('userSubmittedEmail');
 
        if (nxg_username) {
  
            jQuery('#input_18_1').attr('value', nxg_username).attr('readonly', 'true');
            //Add class to label if email value found
            if(jQuery('#input_18_1').val()){
                jQuery('#input_18_1').closest('li').find('label').addClass('active-label-value');
            }
 
        }
 
    }

    //Enable floating label class on form labels which have values in input
    jQuery('.floating-labels-form .enable-label input, .floating-labels-form .enable-label textarea').each(function(field) {
        if (jQuery(this).val() !== "") {
            jQuery(this).parent().addClass('has-value');
            jQuery(this).parent().parent().find('label').addClass('active-label-value');
        }
    });
  
});

//Aqfer Tag Fire on Form Submit
//WEB-1021 Scope
jQuery(document).on("submit", ".gform_wrapper form", function(event) {
    console.log(jQuery(this));

    var formID = jQuery('.gform_wrapper form').attr('id');

    //Aqfer Vars
    var userFullName = '';
    var userEmail = '';
    var userPhone = '';
    var userCompany = '';

    //For common inputs
    userEmail = jQuery(this).find('input[type="email"]').val();
    userPhone = jQuery(this).find('input[type="tel"]').val();

    if(formID == 'gform_9'){
        userFullName = jQuery(this).find('#input_9_1').val();
        userCompany = jQuery(this).find('#input_9_6').val();

        console.log(formID, userEmail,userPhone,userFullName,userCompany);
        if(userEmail !== ''){
            var pixelUrl = '';
            if(dax_obj.site_env === 'PROD'){
                pixelUrl = 'https://tag.salesgenie.com/1/e/c.gif?aqet=eng&aqet_l1=sg_formfill&v0='+encodeURIComponent(userEmail)+'&v3='+encodeURIComponent(userFullName)+'&v4='+encodeURIComponent(userPhone)+'&v5='+encodeURIComponent(userCompany);
            }
            else{
                pixelUrl = 'https://tag.salesgenie.com/1/e/c.gif?cls=staging&aqet=eng&aqet_l1=sg_formfill&v0='+encodeURIComponent(userEmail)+'&v3='+encodeURIComponent(userFullName)+'&v4='+encodeURIComponent(userPhone)+'&v5='+encodeURIComponent(userCompany);
            }
            console.log(pixelUrl,'purl_gvty');
            // Create and append the pixel image
            var pixelImage = new Image();
            pixelImage.src = pixelUrl;
            pixelImage.style.display = 'none'; // Hide the image from view
            document.body.appendChild(pixelImage);
        }
    }

});

jQuery(document).ready(function() {

    // force cursor placement on input masked phone field only when empty of characters
   var maskedPhones = document.querySelectorAll('.gfield .ginput_container_phone input');

   for (i = 0; i < maskedPhones.length; ++i) {

      maskedPhones[i].addEventListener('mouseup', function(e) {

            if ( e.currentTarget.value.replace(/\(|\)|_|-|\./g,'').trim() == '' ) {

               e.currentTarget.setSelectionRange(0,0);

            }

       });

   }

    // insert the show/hide eye icons after the .password-eye input
   jQuery('<i class="show-password password-eye-icon fas fa-eye" aria-hidden="true"></i><i class="hide-password password-eye-icon fas fa-eye-slash" aria-hidden="true"></i>').insertAfter('.password-eye input');


   // show/hide the masked password when the eye icons are clicked
   jQuery('.password-eye-icon').click(function() {

      if (jQuery(this).hasClass('show-password')) {

         jQuery('.password-eye input').attr('type', 'text');

         jQuery(this).hide();

         jQuery('.hide-password').show();

      } else if (jQuery(this).hasClass('hide-password')) {

         jQuery('.password-eye input').attr('type', 'password');

         jQuery(this).hide();

         jQuery('.show-password').show();

      }

   });

});

jQuery(document).on('click', '.gform_button', function () {
    const $button = jQuery(this);
    const $form = $button.closest('form');
    const formId = $form.attr('id')?.match(/\d+/)?.[0];
    if (!formId) return;
  
    const isAjax = ($form.attr('target') || '').includes('gform_ajax');
    if (!isAjax) {
      jQuery(`#gform_ajax_spinner_${formId}`).show();
    }
  
    $button.val('SENDING...').css('pointer-events', 'none');
  });